import * as React from "react";
import DashboardOverViewEmployee from "./DashboardOverViewEmployee";
import DashboardRankingEmployee from "./DashboardRankingEmployee";

import ModernCard from "../../core/ModernCard";

import { useState } from "react";
import DashboardHeader from "./DashboardHeader";
import Loader from "../../core/Loader";

function CommissionDashboardEmployee({
  user,
  commissions,
  loadingCommissions,
}) {
  const [currentView, setCurrentView] = useState("overviewReport");
  const viewProps = {
    user: user,
    commissions: commissions,
  };
  const views = {
    overviewReport: <DashboardOverViewEmployee {...viewProps} />,
    rankingReport: <DashboardRankingEmployee {...viewProps} />,
  };
  const dashboardOptions = [
    { label: "Overview Report", value: "overviewReport" },
    { label: "Ranking Report", value: "rankingReport" },
  ];
  return (
    <ModernCard title={"Dashboard"} ta="left" m="0px">
      {loadingCommissions ? (
        <Loader />
      ) : commissions &&
        Array.isArray(commissions) &&
        commissions.length > 0 ? (
        <>
          <DashboardHeader
            title={
              dashboardOptions.find(obj => obj.value === currentView)["label"]
            }
            menuOptions={dashboardOptions}
            currentView={currentView}
            setCurrentView={setCurrentView}
          />
          {views[currentView]}
        </>
      ) : (
        <div>No commissions found</div>
      )}
    </ModernCard>
  );
}

export default CommissionDashboardEmployee;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/CommissionDashboardEmployee.tsx